import { NavLink } from 'react-router-dom';

import { getPrimaryTabItems } from '@/app/shell/navigationManifest';
import { closeSideDrawer, openSideDrawer } from '@/features/ui/store/uiSlice';
import { useAppDispatch } from '@/hooks/useAppDispatch';
import { useAppSelector } from '@/hooks/useAppSelector';
import { cn } from '@/utils/cn';

export function BottomNav() {
  const dispatch = useAppDispatch();
  const isDrawerOpen = useAppSelector((state) => state.ui.isSideDrawerOpen);
  const permissions = useAppSelector((state) => state.auth.permissions);
  const navItems = getPrimaryTabItems(permissions);

  return (
    <nav className="app-bottom-nav-shell pb-safe fixed bottom-0 left-0 right-0 z-30 dark:bg-slate-950 lg:hidden">
      <div className="app-bottom-nav-frame mx-auto max-w-3xl rounded-[1.9rem] border border-white/70 bg-white/80 shadow-[0_18px_44px_-28px_rgba(15,23,42,0.28)] ring-1 ring-slate-900/5 backdrop-blur-3xl dark:border-slate-800 dark:bg-slate-900 dark:shadow-[0_20px_44px_-24px_rgba(2,6,23,1)] dark:ring-slate-700/60 dark:backdrop-blur-none">
        <ul className="app-bottom-nav-grid grid grid-cols-5">
          {navItems.map((item) => (
            <li key={item.key}>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  cn(
                    'app-bottom-nav-item tap-target group flex flex-col items-center justify-center gap-1.5 px-1.5 py-2.5 text-[11px] font-medium leading-none transition-all duration-200 active:scale-[0.98]',
                    isActive
                      ? 'bg-gradient-to-b from-brand-500 to-brand-600 text-white shadow-[0_14px_26px_-20px_rgba(37,99,235,0.85)] ring-1 ring-white/20 dark:from-brand-500 dark:to-brand-600 dark:text-white dark:shadow-[0_16px_28px_-22px_rgba(37,99,235,0.95)] dark:ring-white/10'
                      : 'text-slate-500 hover:bg-white/70 hover:text-slate-900 active:bg-white/90 dark:text-slate-500 dark:hover:bg-slate-800 dark:hover:text-slate-100 dark:active:bg-slate-800/90'
                  )
                }
              >
                {({ isActive }) => (
                  <>
                    <span
                      className={cn(
                        'flex h-8 w-8 items-center justify-center rounded-full transition-all duration-200',
                        isActive
                          ? 'bg-white/18 shadow-[inset_0_1px_0_rgba(255,255,255,0.18)]'
                          : 'bg-transparent group-hover:bg-slate-900/5 dark:group-hover:bg-slate-700/80'
                      )}
                    >
                      <item.icon className="h-[18px] w-[18px] shrink-0" />
                    </span>
                    <span className="whitespace-nowrap text-[11px] tracking-[0.01em]">
                      {item.title === 'Dashboard' ? 'Home' : item.title}
                    </span>
                  </>
                )}
              </NavLink>
            </li>
          ))}
          <li>
            <button
              type="button"
              aria-label={isDrawerOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={isDrawerOpen}
              className={cn(
                'app-bottom-nav-item tap-target group flex w-full flex-col items-center justify-center gap-1.5 px-1.5 py-2.5 text-[11px] font-medium leading-none transition-all duration-200 active:scale-[0.98]',
                isDrawerOpen
                  ? 'bg-slate-900 text-white shadow-[0_14px_26px_-20px_rgba(15,23,42,0.6)] ring-1 ring-white/10 dark:bg-slate-800 dark:text-white dark:shadow-[0_16px_28px_-22px_rgba(2,6,23,0.95)] dark:ring-slate-700/80'
                  : 'text-slate-500 hover:bg-white/70 hover:text-slate-900 active:bg-white/90 dark:text-slate-500 dark:hover:bg-slate-800 dark:hover:text-slate-100 dark:active:bg-slate-800/90'
              )}
              onClick={() => dispatch(isDrawerOpen ? closeSideDrawer() : openSideDrawer())}
            >
              <span
                className={cn(
                  'flex h-8 w-8 items-center justify-center rounded-full transition-all duration-200',
                  isDrawerOpen
                    ? 'bg-white/18 shadow-[inset_0_1px_0_rgba(255,255,255,0.18)]'
                    : 'bg-transparent group-hover:bg-slate-900/5 dark:group-hover:bg-slate-700/80'
                )}
              >
                <span className="relative block h-4 w-5 shrink-0">
                  <span
                    aria-hidden="true"
                    className={cn(
                      'absolute left-0 top-0.5 h-0.5 w-5 rounded-full bg-current transition duration-200 ease-out',
                      isDrawerOpen ? 'translate-y-[5px] rotate-45' : ''
                    )}
                  />
                  <span
                    aria-hidden="true"
                    className={cn(
                      'absolute left-0 top-[7px] h-0.5 w-5 rounded-full bg-current transition duration-200 ease-out',
                      isDrawerOpen ? 'scale-x-0 opacity-0' : ''
                    )}
                  />
                  <span
                    aria-hidden="true"
                    className={cn(
                      'absolute left-0 top-[13px] h-0.5 w-5 rounded-full bg-current transition duration-200 ease-out',
                      isDrawerOpen ? '-translate-y-[7px] -rotate-45' : ''
                    )}
                  />
                </span>
              </span>
              <span className="whitespace-nowrap text-[11px] tracking-[0.01em]">Menu</span>
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
}
